<template>
  <div>
    <v-container>
      <div class="text-xl text-center">
        <v-icon left>mdi-newspaper-variant-outline</v-icon>
        {{ $t('project.news_board', {name: project.name}) }}
      </div>
      <div class="text-center mt-3">
        <v-btn @click="isAddDailog = true" width="800px" color="info">
          <v-icon left>mdi-text-box-plus-outline</v-icon>{{ $t('project.post_for_seller') }}
        </v-btn>
      </div>
      <div class="text-center mt-5" v-if="isLoading">
        <v-progress-circular :value="20" indeterminate color="success" :size="50" :width="5"></v-progress-circular>
      </div>
      <v-card :loading="isLoading" class="mx-auto my-5" max-width="800" v-for="(post, index) in posts" :key="index"
        :to="`/project/${project.objectId}/board/${post.objectId}`">
        <template slot="progress">
          <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <template v-if="post.images && post.images.length">
          <v-skeleton-loader class="m-0 load-image-post" type="image" height="250px" min-height="250px" width="100%"
            v-if="isLoadImagePost[index]"></v-skeleton-loader>
          <img v-show="!isLoadImagePost[index]" class="image-post" height="250px" :src="post.images[0].url"
            @load="loadImagePost(index)" />
        </template>

        <v-card-text style="padding:0;">
          <div class="p-4 flex name-box">
            <v-icon>mdi-account-circle</v-icon>
            <div style="max-width:calc(100% - 50px);">
              <div class="text-fullname">
                {{ post.createdFullName }}
                <v-chip v-if="post.admin" color="rgb(209,242,225)" small class="green--text" style="transform: scale(.9)">
                  {{ $t('project.admin') }}
                </v-chip>
                <v-chip v-if="post.employees && post.employees.length" color="rgb(209,242,225)" small class="green--text"
                  style="transform: scale(.9)">
                  {{ $t('project.employee') }}
                </v-chip>
              </div>
              <div class="text-position">
                <span>{{ post.agoCreatedAt }}</span>
              </div>
            </div>
          </div>
          <div class="text-nowrap-title" v-if="post.title">{{ post.title }}</div>
          <div class="text-nowrap-lines" v-if="post.preview">{{ post.preview }}</div>
          <div class="text-right p-1 px-4" style="font-size:13px;">
            <v-icon small>mdi-eye</v-icon>
            {{ $t('project.seen_post', {count: post.seenCount || 0}) }}
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="bg-gray-100">
          <PostPrivacyTooltip :post="post"></PostPrivacyTooltip>
          <v-spacer></v-spacer>
          <div class="text-comment-length" v-if="!post.disableComment || post.commentLength">
            <span>
              <v-icon class="mr-1">mdi-comment</v-icon>
              {{ post.commentLength || 0 }} {{ $t('project.comment') }}
            </span>
          </div>
        </v-card-actions>
      </v-card>
      <div class="text-center mt-5" v-if="isFetching">
        <v-progress-circular :value="20" indeterminate color="success" :size="50" :width="5"></v-progress-circular>
      </div>
      <div class="text-center mt-5 text-gray-300" v-if="getNoMoreData">{{ $t('noinfo') }}</div>
      <v-card v-intersect="infiniteScrolling" class="hide-card" outlined></v-card>
    </v-container>
    <v-dialog v-model="isAddDailog" max-width="600px" persistent scrollable>
      <v-card outlined>
        <v-card-title class="blue white--text card-title-dialog">
          <h3>{{ $t('create_post') }}</h3>
          <v-btn class="close-icon" color="white" icon @click="isAddDailog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
          <v-overlay v-show="isLoadPost" opacity="0.3" color="white">
            <v-progress-circular :value="20" indeterminate color="success" :size="100"
              :width="7">{{ $t('posting') }}</v-progress-circular>
          </v-overlay>
          <div class="flex p-4 name-box">
            <v-icon>mdi-account-circle</v-icon>
            <div style="max-width:calc(100% - 50px);">
              <div class="text-fullname">{{ getFullName }}</div>
              <PostPrivacyTooltip :privacy="canSee" :markets="whoSee"></PostPrivacyTooltip>
            </div>
          </div>
          <v-text-field v-model="title" :placeholder="$t('project.news_board_title')" color="gray" style="font-size:20px;"
            class="mx-10 shadow-none font-semibold"></v-text-field>
          <v-divider class="mx-2"></v-divider>
          <v-textarea v-model="preview" rows="3" :placeholder="$t('project.write_for_seller')" color="gray" auto-grow
            style="font-size:18px;" class="mx-10 shadow-none">
            <template v-slot:progress>
              <v-progress-linear color="white" absolute height="1"></v-progress-linear>
            </template>
          </v-textarea>
          <template v-if="images && images.length">
            <v-divider></v-divider>
            <div class="mx-5 my-4">{{ $t('project.image_post') }}</div>
            <div class="mx-5">
              <div v-for="(image, index) in images" :key="index" class="img-box">
                <v-icon color="red" @click="images.splice(index, 1)" :disabled="isFormImageLoading">mdi-close</v-icon>
                <img :src="image.url" :alt="`image-board-upload-${index}`" />
              </div>
              <v-skeleton-loader class="img-skeleton" type="image" v-if="isFormImageLoading"></v-skeleton-loader>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="input-box bg-gray-100">
            <label for="input-file-board">
              <span>{{ $t('addimage') }}</span>
              <v-icon color="green" :disabled="isFormImageLoading">mdi-image-multiple</v-icon>
            </label>
            <v-file-input id="input-file-board" class="input-file" accept="image/*" v-model="imagesTmp"
              @change="uploadFile($event, images)" multiple prepend-icon hide-input :loading="isFormImageLoading"
              :disabled="isFormImageLoading"></v-file-input>
          </div>
          <v-spacer></v-spacer>
          <v-select class="w-min slelct-box input v-size--small" :items="canSeeLabel" v-model="canSee" color="gray"
            item-color="info" append-icon="mdi-chevron-down" outlined :no-data-text="$t('noinfo')"
            :disabled="isFormImageLoading || isLoadPost || isLoading" :hide-details="whoSee.length > 0 ? false : true"
            :messages="`${$t('project.have_market_to_see_post', {count: whoSee.length > 0 ? whoSee.length.toString() : ''})}`">
            <template v-slot:selection="{ item }">
              <v-icon v-if="item.icon" class="mr-2">{{ item.icon }}</v-icon>
              <span v-if="item.text">{{ item.text }}</span>
            </template>
            <template v-slot:item="{ item }">
              <div class="py-2 w-100" @click="canSeeClick(item)">
                <v-icon v-if="item.icon" class="mr-1">{{ item.icon }}</v-icon>
                <span v-if="item.text" class="mi-vertical-align-center">{{ item.text }}</span>
                <div v-if="item.note" class="pl-2">
                  <small>{{ item.note }}</small>
                </div>
              </div>
            </template>
          </v-select>
        </v-card-actions> 
        <v-card-actions>
          <v-checkbox v-model="enableComment" class="mt-0 pt-0 mb-1" :label="$t('project.allow_comment')"
            hide-details></v-checkbox>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions>
          <div v-if="!isAdmin && whoSee.length == 0" class="text-red">*{{ $t('validate.please_select_market') }}</div>
          <v-spacer></v-spacer>
          <v-btn :disabled="isLoading" text outlined elevation="0" @click="isAddDailog = false"
            :loading="isLoading || isLoadPost">{{ $t('cancel') }}</v-btn>
          <v-btn :loading="isLoading || isLoadPost" color="info" elevation="0" @click="postClick()"
            :disabled="!title || isLoadPost || isFormImageLoading || (!isAdmin && whoSee.length == 0 ? true : false)">{{ $t('post') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isMarketDailog" max-width="600px" persistent scrollable>
      <v-card outlined>
        <v-card-title color="white" class="flex justify-space-between shadow">
          <div>{{ $t('project.select_market_for_post') }}</div>
          <v-btn icon @click="isMarketDailog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card v-for="(userProject, index) in currentProject()" :key="`user-project-${index}`" class="mt-5">
            <v-card-title class="pb-0 flex justify-space-between">
              <div>{{ $t('project.project_name', {name: userProject.project.name}) }}</div>
              <div>
                <v-btn color="success" small text
                  @click="whoSeeProject(true, userProject.project.objectId)">{{ $t('project.select_all_project') }}</v-btn>
                <v-btn color="error" small text
                  @click="whoSeeProject(false, userProject.project.objectId)">{{ $t('project.unselect_all_project') }}</v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <template v-if="userProject.markets && userProject.markets.length">
                <v-checkbox v-for="(market, indexIn) in userProject.markets" :key="indexIn"
                  @change="whoSeeInput($event, market)" :value="whoSeeCheck(market)" hide-details color="info"
                  :label="`${market.name}`"></v-checkbox>
              </template>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="isMarketDailog = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FileUpload } from "../../classes";
import PostPrivacyTooltip from "../../components/PostPrivacyTooltip.vue";
export default {
  components: {
    PostPrivacyTooltip
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      isLoading: false,
      isFetching: false,
      selection: 1,
      isAddDailog: false,
      isMarketDailog: false,
      isFormImageLoading: false,
      canSee: 1,
      title: "",
      preview: "",
      enableComment: false,
      whoSee: [],
      images: [],
      imagesTmp: null,
      canSeeLabel: [
        {
          value: 1,
          text: this.$t('project.see_all_market'),
          note: this.$t('project.all_market_in_project'),
          icon: "mdi-earth",
          disabled: false,
        },
        {
          value: 2,
          text: this.$t('project.see_only_market'),
          note: this.$t('project.select_post_only_market'),
          icon: "mdi-account-group",
          disabled: false,
        }
      ],
      isLoadImagePost: [],
      isLoadPost: false
    };
  },
  computed: {
    ...mapGetters({
      getFullName: "user/getFullName",
      user: "user/getUserInfo",
      posts: "post/getPosts",
      getNoMoreData: "post/getNoMoreData",
      getAdminByProjectId: "admin/getByProjectId",
      getEmployeeByProjectId: "employee/getByProjectId",
    }),
    admins() {
      return this.getAdminByProjectId(this.projectId);
    },
    isAdmin() {
      let res = false
      if (this.admins && this.admins.length) res = true
      return res
    },
    employees() {
      return this.getEmployeeByProjectId(this.projectId);
    },
    project() {
      let project;
      if (this.admins && this.admins.length > 0)
        project = this.admins[0].project;
      if (!project && this.employees && this.employees.length > 0)
        project = this.employees[0].project;
      return project;
    },
    sessionObjectId() {
      let adminId;
      let employeeIds;
      if (this.admins && this.admins.length) {
        adminId = this.admins[0].objectId
      } else if (this.employees && this.employees.length) {
        employeeIds = this.employees.map(d => d.objectId)
      }
      return {
        adminId,
        employeeIds
      }
    },
    userProjects() {
      let projects = {};
      if (this.user && this.user.admins && this.user.admins.length > 0) {
        for (const admin of this.user.admins) {
          let tmk = null;
          if (!projects[admin.project.objectId]) {
            projects[admin.project.objectId] = {};
            projects[admin.project.objectId].project = admin.project;
            projects[admin.project.objectId].markets = [];
          }
          if (
            projects[admin.project.objectId].markets &&
            projects[admin.project.objectId].markets.length
          ) {
            tmk = projects[admin.project.objectId].markets.find(
              mk => mk.objectId == admin.market.objectId
            );
          }
          if (!tmk) projects[admin.project.objectId].markets.push(admin.market);
        }
      }
      if (this.user && this.user.employees && this.user.employees.length > 0) {
        for (const employee of this.user.employees) {
          let tmk = null;
          if (!projects[employee.project.objectId]) {
            projects[employee.project.objectId] = {};
            projects[employee.project.objectId].project = employee.project;
            projects[employee.project.objectId].markets = [];
          }
          if (
            projects[employee.project.objectId].markets &&
            projects[employee.project.objectId].markets.length
          ) {
            tmk = projects[employee.project.objectId].markets.find(
              mk => mk.objectId == employee.market.objectId
            );
          }
          if (!tmk)
            projects[employee.project.objectId].markets.push(employee.market);
        }
      }

      return projects;
    }
  },
  watch: {
    isAddDailog(value) {
      if (value) {
        // this.clearData();
        if (!this.isAdmin) { this.canSeeLabel[0].disabled = true; this.canSee = 2 }
      }
    },
    isMarketDailog(value) {
      if (value) {
        // this.clearData();
      } else {
        if (this.isAdmin && this.whoSee.length == 0) {
          this.canSee = 1;
        } else if (
          this.isAdmin &&
          this.project.objectId &&
          this.userProjects &&
          this.userProjects[this.project.objectId] &&
          this.userProjects[this.project.objectId].markets &&
          this.whoSee.length ==
          this.userProjects[this.project.objectId].markets.length
        ) {

          this.canSee = 1;
          this.whoSee = [];
        }
      }
    }
  },
  created() {
    if (
      !(this.admins?.length || this.employees?.find(d => d.enableViewBoard))
    ) {
      this.$router.push(`/notFound`);
    }
    this.getPosts();
  },
  mounted() {
    this.setProjectId(this.$route.params.projectId);
  },
  methods: {
    setProjectId(projectId) {
      this.$store.commit("markets/setProjectId", {
        projectId: projectId
      });
    },
    async getPosts(isMore = false) {
      if (isMore) {
        this.isFetching = true;
        await this.$store.dispatch("post/fetchPosts", {
          projectId: this.projectId
        });
        this.isFetching = false;
      } else {
        this.isLoading = true;
        await this.$store.dispatch("post/getPosts", {
          projectId: this.projectId
        });
        this.isLoading = false;
      }
      // for (const post of this.posts) {
      //   this.isLoadImagePost.push(true);
      // }
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (!this.isFetching && !this.isLoading && !this.getNoMoreData) {
        this.getPosts(true);
      }
    },
    async uploadFile(images, to = []) {
      if (images) {
        try {
          this.isFormImageLoading = true;
          for (const image of images) {
            const data = await FileUpload.upload(image);
            to.push(data);
          }
          this.isFormImageLoading = false;
        } catch (err) {
          console.log("~ err", err);
          this.isFormImageLoading = false;
        }
        this.imagesTmp = null;
      }
    },
    async postClick() {
      this.isLoadPost = true;
      try {
        await this.$store.dispatch("post/createPost", {
          title: this.title,
          preview: this.preview,
          images: this.images || [],
          disableComment: !this.enableComment,
          markets: this.whoSee.map(mk => mk.objectId) || [],
          projectId: this.projectId,
          privacy: this.canSee || 1,
          ...this.sessionObjectId
        });
        this.isLoadPost = false;
        this.$toast.show({
          content: this.$t('post_success'),
          color: "success"
        });
      } catch (error) {
        console.log(error);
        this.isLoadPost = false;
        this.$toast.show({
          content: this.$t('postfailed'),
          color: "error"
        });
      }
      this.isAddDailog = false;
      this.getPosts();
      this.clearData();
    },
    clearData() {
      this.images = [];
      this.imagesTmp = null;
      this.canSee = 1;
      this.preview = "";
      this.title = "";
    },
    canSeeClick(item) {
      if (item.value == 2) {
        this.isMarketDailog = true;
      } else {
        this.whoSee = [];
      }
    },
    whoSeeInput(value, market) {
      if (value) {
        this.whoSee.push(market);
      } else {
        let index = this.whoSee.findIndex(mk => mk.objectId == market.objectId);
        if (index >= 0) {
          this.whoSee.splice(index, 1);
        }
      }
    },
    whoSeeCheck(market) {
      let res = false;
      let ck;
      if (this.whoSee && this.whoSee.length) {
        ck = this.whoSee.find(mk => mk.objectId == market.objectId);
        if (ck) res = true;
      }
      return res;
    },
    whoSeeProject(value, projectObjectId) {
      if (
        this.userProjects[projectObjectId] &&
        this.userProjects[projectObjectId].markets
      ) {
        for (const market of this.userProjects[projectObjectId].markets) {
          let ck = this.whoSee.findIndex(mk => mk.objectId == market.objectId);
          if (value) {
            if (ck < 0) {
              this.whoSee.push(market);
            }
          } else {
            if (ck >= 0) {
              this.whoSee.splice(ck, 1);
            }
          }
        }
      }
    },
    loadImagePost(index) {
      this.isLoadImagePost[index] = false;
      this.$forceUpdate();
    },
    currentProject() {
      if (this.project.objectId && this.project.objectId)
        return [this.userProjects[this.project.objectId]];
      else return [];
    }
  }
};
</script>

<style lang="scss" scoped>
.close-icon {
  position: absolute;
  top: 9px;
  right: 9px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.close-icon:hover {
  background: rgba(0, 0, 0, 0.3);
  transform: scale(1.1);
}

.card-title-dialog {
  display: block;
  text-align: center;
  padding: 13px 0 !important;
}

.board-box {
  height: calc(100vh - 26px);
  position: relative;
}

.img-box {
  position: relative;
  width: 150px;
  height: 150px;
  display: inline-flex;
  margin: 0 5px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  img {
    position: relative;
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
  }

  .v-icon {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 2;
    padding: 5px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.08);
  }

  .v-icon:hover {
    background: rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
  }

  .v-icon:focus::after {
    opacity: 0;
  }
}

.v-skeleton-loader {
  width: 150px;
  height: 150px;
  margin: 0 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-block;
}

.input-box {
  cursor: pointer;
  align-self: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 7px 15px;

  label {
    cursor: pointer;
    display: inline-flex;
    vertical-align: middle;

    span {
      margin-right: 5px;
    }
  }

  .v-input {
    display: none;
  }
}

.name-box {
  .v-icon {
    font-size: 40px;
    margin-right: 5px;
  }

  .text-fullname {
    font-size: 18px;
  }

  .text-position {
    font-size: 15px;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .v-icon {
      font-size: 12px;
    }

    span {
      font-size: 12px;
    }
  }
}

.text-position-b {
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgb(155, 155, 155);

  .v-icon {
    font-size: 12px;
    margin-right: 5px;
  }

  span {
    font-size: 12px;
  }
}

.v-input__slot {
  box-shadow: none;
}

.slelct-box {
  // background: rgba(0, 0, 0, 0.1);
  outline-color: rgba(0, 0, 0, 0.1);
  min-height: unset;
  max-width: 200px;

  .v-input__append-inner {
    margin-top: 0;
  }

  .v-input__slot {
    min-height: unset;
  }
}

.slelct-box::v-deep .v-input__slot {
  min-height: unset;
}

.slelct-box::v-deep .v-select__selections {
  padding: 5px 0 !important;
}

.slelct-box::v-deep .v-input__append-inner {
  margin: auto 0;
  padding-left: 0;
}

.load-image-post {
  margin: 0 !important;
}

.load-image-post::v-deep .v-skeleton-loader__image {
  height: 250px;
}

img.image-post {
  height: 250px;
  width: 100%;
  object-fit: cover;
}

.hide-card {
  box-shadow: none !important;
  background: rgba(0, 0, 0, 0) !important;
  border: none !important;
}

.text-nowrap-title {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 30px 25px 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-height: 20px;
  max-height: 40px;
  -webkit-box-orient: vertical;
}

.text-nowrap-lines {
  text-indent: 10px;
  margin: 10px 30px 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 20px;
  max-height: 40px;
  -webkit-box-orient: vertical;
}

.text-comment-length {
  cursor: default;
  font-size: 15px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .v-icon {
    color: gray;
    font-size: 12px;
  }

  span {
    color: gray;
    font-size: 12px;
  }
}
.text-red{
  color: var(--v-error-base);
}
</style>